import axios from "axios";
import { useMemo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTypedSelector } from "../../../app/store";
import {
  fetchInstalledAppDetail,
  clearInstalledAppDetail,
} from "../InstalledAppSlice";
import { InstalledApplicationDetail } from "../types/InstalledApplicationDetail";

export const useInstalledAppDetail = () => {
  // パスからappIdを取得する
  const { id: appId } = useParams<{ id?: string }>();

  const [isLoading, setIsLoading] = useState(true);

  const wholeState = useTypedSelector((x) => ({
    ...x.login,
    ...x.installedApplication,
  }));
  const dispatch = useDispatch();
  const history = useHistory();

  const appDetail: InstalledApplicationDetail | null = useMemo(() => {
    const tempDetail = wholeState.selectInstalledApp;

    // stateから取得した連携アプリ詳細が不正ならnullを返す
    if (!tempDetail) return null;
    if (
      !tempDetail.applicationId ||
      !tempDetail.name ||
      !tempDetail.description ||
      !tempDetail.productId ||
      !tempDetail.type ||
      !tempDetail.uri
    )
      return null;
    return tempDetail as InstalledApplicationDetail;
  }, [wholeState.selectInstalledApp]);

  // ロードが完了しているのに連携アプリが無い場合は一覧に戻る
  if (!isLoading && !appDetail) history.push("/manager/installed-applications");

  // ロード状態を反映
  useEffect(() => {
    // ちらつき防止で0.5秒遅らせる
    const delay = setTimeout(() => {
      setIsLoading(wholeState.isLoadings.fetchInstalledAppDetail);
    }, 500);

    // アンマウント
    return () => {
      clearTimeout(delay);
    };
  }, [wholeState.isLoadings.fetchInstalledAppDetail]);

  // マウント
  useEffect(() => {
    const source = axios.CancelToken.source();

    // urlにappIdが存在するなら取得する
    if (appId) {
      dispatch(
        fetchInstalledAppDetail({
          accessToken: wholeState.accessToken!,
          applicationId: appId,
          cancelToken: source.token,
        })
      );
    } else {
      dispatch(clearInstalledAppDetail());
    }

    // アンマウント
    return () => {
      // 詳細のstateを削除
      dispatch(clearInstalledAppDetail());
      // リクエスト中ならキャンセル
      source.cancel();
    };
  }, [appId, wholeState.accessToken, dispatch]);

  return {
    appDetail,
    isLoading,
  };
};
